global = typeof global !== 'undefined' ? global : window;
global.MESSAGES = (typeof MESSAGES !== 'undefined') ? MESSAGES : {};

global.MESSAGES.uk_ua = {
    locale: {
        uah: 'грн'
    },

    calculator: {
        select_payment_method:         'Вкажіть спосіб оплати. Оплачуватимете товар до відправки або при отриманні?',
        select_payment_method_caption: 'Ви не вказали спосіб оплати',
        empty_basket:                  'Для того, щоб ми могли розрахувати вартість доставки товару - додайте необхідний товар у кошик',
        empty_basket_caption:          'Ваш кошик порожній',
	    unsupported_region:            'На жаль, ми не можемо порахувати доставку в даний регіон',
        address_delivery_error:        'Адресная доставка возможна только при предоплате'
    },

    cart: {
        empty:                        'Для того, щоб оформити замовлення треба, перш за все, додати в кошик необхідні товари',
        empty_caption:                'Ваш кошик порожній',
        sure_to_clear_all:            'Точно видалити ВЕСЬ товар з кошика?',
        sure_to_clear_all_caption:    'Видалення товару',
        sure_to_clear_all_yes:        'Видалити',
        alert_delete_ok_btn:          'Видалити',
        alert_delete_cancel_btn:      'Скасувати',
        alert_delete_message:         'Точно видалити цей товар з кошика?',
        alert_delete_message_caption: 'Видалення товару',
        alert_delete_message_yes:     'Видалити',
        how_much:                     'Скільки Вам потрібно?',
        how_much_full:                'Скільки {name} Вам потрібно?',
        cannot_add_less_1:            'Додати можна не менше 1 штуки',
        cann_add_only_numeric:        'Значення має бути коректним цілим числом',
        cann_add_less_1_full:         'Додати можна не менше 1 {name}',
        no_items:                     'Кошик порожнiй',
        save_quantity_error:          'Сталася помилка при збереженні кількості',
        error:                        'Помилка',
        guarantee_item:               'Ця запчастина для гарантійної заявки №',
        guarantee_alert:              'Вкажіть номери заявок в системі Regulus, для всіх гарантійних запчастин',

        when_ordering:         'Ви почали оформлення замовлення і не можете редагувати товари в кошику. <br> Якщо Ви хочете скасувати оформлення і перейти до редагування тисніть <a href="/korzina.html" title="Повернутися до редагування кошика" style = "color:#316bca; font-weight:bold; ">сюди</a>',
        when_ordering_caption: 'Йде оформлення замовлення',
        its_cart:              'Ви вже переглядаєте Ваш кошик. <br> Якщо Ви хочете приступити до оформлення замовлення - тисніть кнопку «Все вірно, приступити до оформлення», яка знаходиться внизу списку обраних товарів. <br> Якщо ж Ви хочете піти звідси - клікайте на будь-яке посилання або <a href="/" title="Перейті на головну" style="color: #316bca; font-weight: bold;">сюди</a>',
        its_cart_caption:      'Це і є корзина',

        you_have: 'У Вас ',
        for_sum:  'На суму ',
	    confirm_transfer_to_order: 'Ви точно хочете перенести товари в замовлення?'
    },

    cartLayout: {
        my_basket: 'Мій кошик',
        total_count: 'У Вас {count}',
        no_items: 'немає товарів',
        total_sum: 'На суму {sum} {currency}',
        no_items_full: 'У Вас немає товарів',
        your_basket: 'Ваш кошик:',
        clear_basket: 'Очистити кошик',
        you_have: 'Ваше замовлення:',
        your_sum: 'На суму:',
        buy_only_available: 'Купити товари тільки в наявності',
        make_preorder: 'Оформити попереднє замовлення',
        preorder_disclaimer: 'У Вашому кошику є товари, які можуть бути відсутніми на складі. Після оформлення попереднього замовлення з Вами зв\'яжеться менеджер для узгодження деталей.',
        make_order: 'Оформити замовлення',
        continue_shopping: 'Продовжити покупки',
        empty: 'У Вас немає в кошику товарів. Додайте необхідні товари в кошик, після чого перейдіть до оформлення замовлення натиснувши кнопку «Оформити замовлення», яка знаходиться трохи нижче праворуч. ',
        productsPlural: '{n, plural, one{товар} few{товару} many{товарів} other{товарів}}',
        discount: 'ЗНИЖКА',
    },

    cartPage: {
        empty_cart: 'Ваш кошик порожній! Поверніться до каталогу товарів, додайте необхідний товар в Вашу корзину і тоді, Ви зможете оформити замовлення. ',
        products_desktop: 'Ваше замовлення: <span class="basket_total3"> {count, plural, one{# товар} few{# товару} many{# товарів} other{# товарів}} </ span>',
        summa_desktop: 'На суму: <span class="basket_total4"> {summa} {currency} </ span>',
        you_have: 'У Вас є {count, plural, one{# замовлення який} few{# замовлення яких} many{# замовлень які} other{# замовлень які}} ми ще не перевірили. Ви можете додати товар з кошика в {count, plural, many{один з цих замовлень} other{це замовлення}} або оформити нове замовлення: ',

        transfer: {
            add: 'Додати товар в замовлення № {order}',
            success: 'Ваш кошик порожній. Всі товари з неї були перенесені в замовлення № {order}. '
        },

        make_order_new: 'Оформити нове замовлення',
        go_make_order: 'Все вірно, приступити до оформлення',
        total_sum: 'Загальна сума: {total}',
    },

    basketItem : {
        delete: 'Видалити з кошика',
        see_full: 'Натисніть, щоб перейти до докладного опису товару',
        quantity: 'к-ть:',
        price: 'Ціна:',
        articul: 'Артикул:',
        code: 'Код товару:',
        name: 'Назва:',
        availability: 'Наявність:',
        renovated_cross: 'Відреставрована хрестовина № {spider_index} від {spider_time}'
    },

    basketUpdatePrices : {
        button: 'Спочатку поновіть ціни',
        tip: 'Ціна на товар змінилася з урахуванням курсів валют. <br> Будь ласка, поновіть ціну.'
    },

    contacts: {
        alert:         'Увага! Дуже часто нам на пошту приходять питання наступного характеру: <br> «Мені треба ТЕН на Indesit ...», або «А цей мотор підійде на пилосос ...?», Або «Який насос мені треба для ...» <br> Це все можна віднести до варіанту запиту запчастин. А для цього у нас є спеціальна форма «<a href="/zapros_zapchastey/" target="_BLANK">Запит запчастин</a>» в верхньому меню нашого сайту. <br> Якщо Ви хочете отримати відповідь на подібні питання, Вам необхідно заповнити цю форму. Справа в тому, що, щоб дати Вам точну відповідь, нам треба точна інформація, і в кожному випадку вона різна. <br> <br> На всі питання, які прийдуть нам на пошту і які стосуються підбору запчастин до техніки - Ви отримаєте стандартну відповідь з посиланням на цю ж форму. <br> Тому, щоб заощадити свій час - відразу заповнюйте її. <br> <br> З усіх інших питань - ласкаво просимо! Заздалегідь дякуємо за розуміння!',
        alert_caption: 'Що не варто писати',

        form_name_short:            'Ім\'я не може бути коротше 2х символів',
        form_name_short_caption:    'Вкажіть Ім\'я',
        form_subject_short:         'Тема листа не може бути коротше 5ти символів',
        form_subject_short_caption: 'Вкажіть тему',
        form_text_short:            'Текст листа не може бути коротше 20ти символів',
        form_text_short_caption:    'Введіть текст листа',
        form_error:                 'Виникла помилка',
    },

    credits: {
        money:                  '{money} грн',
        collapse:               'Згорнути',
        expand:                 'Поповнити',
        wrong_sum:              'Ви невірно вказали суму поповнення. Сума не може бути менше 1грн.',
        wrong_sum_caption:      'Невірна сума',
        sms_sent:               'СМС з реквізитами відправлено на вказаний Вами номер.',
        sms_sent_caption:       'СМС відправлено.',
        sms_error:              'При відправці СМС сталася помилка',
        email_sent:             'Лист з реквізитами відправлено на вказану Вами адресу.',
        email_sent_caption:     'Лист відправлено.',
        email_error:            'При відправці листа сталася помилка',
        payment_error:          'Помилка при створенні платіжки',
        payment_2_error:        'Помилка 2 при створенні платіжки',
        wrong_payment_method:   'Помилка визначення способу оплати',
        continue:               'Продовжити',
        dont_continue:          'Ее продовжувати',
        w1_alert:               'При оплаті через систему «Єдина каса» Вам необхідно сплатити «Внутрішню комісію» в розмірі 5% від суми платежу. <br> Тому, до оплати в цій системі буде запропонована сума на 5% вище, тієї яку Ви вказали. <br> <br> наприклад: Вам необхідно оплатити нам 100грн. При здійсненні платежу по системі «Єдина каса» наш сайт автоматично збільшить платіж до 105грн. (на 5%). <br> Після того, як платіж буде виконаний - на Ваш баланс, в нашому магазині, буде зарахування 100грн., а 5грн. піде на оплату, тієї самої «внутрішньої комісії». <br> Детальніше <a href="/ua/faq/pochemu-k-platezham-edinyj-koshelek-pribavljaetsja-5.html" target="_ BLANK" style="color: #4182b4;">ТУТ</a>.',
        w1_alert_caption:       'Увага!',
        w1_alert_continue:      'Продовжити',
        w1_alert_dont_continue: 'Не продовжувати',
        limit_error:            'Помилка при роботі з кредитним лімітом, зверніться до нас в офіс.',
        saved_card_paid:        'Оплата успішно зарахована на Ваш баланс',
        saved_card_paid_title:  'Успішно оплачено',
        saved_card_delete:      'Видалити карту?'
    },

    finder: {
        form_model_short:         'Назва моделі має складатися не менше ніж з 4-х символів',
        form_model_short_caption: 'Невірний формат моделі',
        error:                    'Помилка',
        to_main_page:             'На головну'
    },

    main: {
        skype_alert:        '1. При дзвінку через Skype час виклику (дозвону) може скласти від декількох секунд до однієї хвилини. <br> <br> 2. Зв\'язок через скайп може бути тільки у вигляді дзвінків до нас. Чат або дзвінки від нас до Вас недоступні. <br> <br> Детальніше про дзвінки Skype <a href="/ua/faq/chto-takoe-on-line-zvonok.html" title="Клікніте, щоб перейти до статье">читайте тут.</a>',
        search_input_short: 'Пошуковий запит повинен містити мінімум 3 символи',
    },

    cabinet: {
        balance: {
            no_orders_ukraine: 'Увага! У Вас немає замовлень які очікують оплати. У зв\'язку з цим, ми не рекомендуємо Вам поповнювати баланс до того моменту, поки наш працівник не перевірить Ваше замовлення і не зв\'яжеться з Вами. <br> Якщо Ви тільки оформили замовлення - він отримує статус «Новий» і перекладається на оплату, тільки після перевірки нашим менеджером (в робочий час). Як правило, після перевірки ми зв\'язуємося з Вами і повідомляємо про необхідність здійснення оплати.',
            no_orders_foreign: 'Увага! Ви не можете поповнити баланс, так як у Вас немає замовлень які очікують оплати. У зв\'язку з цим, ми не рекомендуємо Вам поповнювати баланс до того моменту, поки наш працівник не перевірить Ваше замовлення і не зв\'яжеться з Вами. <br> Якщо Ви тільки оформили замовлення - він отримує статус «Новий» і перекладається на оплату, тільки після перевірки нашим менеджером (в робочий час). Як правило, після перевірки ми зв\'язуємося з Вами і повідомляємо про необхідність здійснення оплати.',
            bigger_sum_ukraine: 'Увага! Ви вказали суму, яка перевищує необхідну суму поповнення, на даний момент. Якщо Ви вирішите повернути собі частину не витрачених коштів - Вам доведеться оплатити всі комісії які виникають при зарахування та повернення залишку. <br> Якщо у Вас виникли питання дзвоніть на 098 000-86-86',
            bigger_sum_foreign: 'Увага! Ви не можете поповнити баланс, так як вказали суму, яка не відповідає необхідній сумі поповнення, на даний момент. <br> Якщо у Вас виникли питання зв\'яжіться з нами, зручним для Вас способом, і ми на них відповімо.'
        },

        orders: {
            cancel_error:                   'Помилка при скасуванні замовлення',
            order_cancelled:                'Ваше замовлення № {id} скасоване',
            order_cancelled_caption:        'Замовлення скасоване',
            error:                          'Помилка',
            cancel:                         'Скасувати',
            dont_cancel:                    'Не скасовувати',
            cancel_order_alert:             'Це єдиний товар в цьому замовленні, тому його не можна видалити із замовлення, але можна скасувати все замовлення. Скасувати його?',
            cancel_order_alert_caption:     'Скасувати замовлення?',
            cancel_order_alert_cancel:      'Скасувати',
            delete:                         'Видалити',
            dont_delete:                    'Не видаляти',
            delete_confirm:                 'Точно видалити цей товар з Вашого замовлення?',
            delete_confirm_caption:         'Видалення товару',
            delete_confirm_delete:          'Видалити',
            delete_error:                   'Помилка при видаленні товару',
            quantity_less_0:                'Кількість товару в замовленні не може бути менше одного. Якщо Ви хочете прибрати цю позицію з замовлення - натисніть на хрестик в лівому, верхньому кутку блоку з цим товаром.',
            quantity_less_0_caption:        'Не вірна кількість',
            quantity_change_error:          'Помилка при збереженні кількості товару',
            cannot_change_quantity:         'Ви не можете змінювати кількість на цей товар в цьому замовленні, так як вже за встановлену кількість знятий завдаток з Вашого балансу. У разі виникнення питань - звертайтеся до наших менеджерів за телефонами вказаними в контактах.',
            cannot_change_quantity_caption: 'Не можна змінити кількість',
            add:                            'Додати',
            dont_add:                       'Не додавати',
            sure_add_from_cart:             'Точно додати всі товари з Вашої корзини в це замовлення?',
            sure_add_from_cart_caption:     'Додати товари?',
            sure_add_from_cart_add:         'Додати',
            empty_cart:                     'Ваша корзина порожня, ми не можемо з неї щось додати в замовлення',
            order_confirm_error:            'Помилка при підтвердженні замовлення',
            cancel_order:                   'Точно скасувати це замовлення?',
            cancel_order_caption:           'Скасувати замовлення?',
            cancel_order_yes:               'Так',
            cancel_order_cancel:            'Нi',
            cannot_change_quantity_reserved: 'Ви не можете змінювати кількість на цей товар в цьому замовленні, так як поточна кількість товару вже зарезервовано. У разі виникнення питань - звертайтеся до наших менеджерів за телефонами вказаними в контактах.',
            cannot_change_quantity_reserved_caption: 'Не можна змінити кількість',
        },

        profile: {
            phone_short:          'Номер телефону занадто короткий',
            phone_taken:          'Цей номер телефону вже закріплений за іншим клієнтом. <br> Якщо це Ваш номер, і Ви не закріплювали цей номер за іншими акаунтами - зверніться до наших співробітників.',
            phone_taken_caption:  'Цей номер вже існує в нашій базі',
            phone_error:          'Виникла помилка',
            phone_delete_confirm: 'Точно видалити цей номер з контактів?',
            error:                'Помилка',
            name_short:           'Введіть Ваші прізвище та ім\'я',
        },

        requests: {
            comment_text_short: 'Текст коментаря занадто короткий',
            error:              'Помилка',
        }
    },

    request: {
        enter_full_model:           'Введіть повну модель',
        enter_prod_number:          'Введіть S/N або Prod номер техніки',
        prod_number_wrong:          'Не вірно вказаний номер',
        code_length_error:          'Код повинен містити від 5-ти до 6-ти цифр. <br> І більше ніяких символів',
        save_error:                 'При збереженні запиту сталася помилка',
        save_error_caption:         'Помилка при збереженні',
        error:                      'Виникла помилка',
        enter_tech:                 'Виберіть вид техніки',
        enter_tech_caption:         'Не вказаний вид техніки',
        enter_brand:                'Виберіть торгову марку',
        enter_brand_caption:        'Не вказана торгова марка',
        model_short:                'Модель не може бути коротше 5-ти символів',
        model_short_caption:        'Не вірно введена модель',
        description_short:          'Детальний опис запчастини занадто короткий, вiн не може бути коротше 10-ти символів',
        description_short_caption:  'Не вірно зазначено опис деталі',
        image_delete_error:         'При видаленні сталася помилка',
        image_delete_error_caption: 'Фото не вилучено',
    },

    reviews: {
        already_voted:             'Ви вже оцінили цей відгук',
        your_own_comment:          'Ви не можете оцінювати свій відгук',
        error:                     'Помилка',
        login_to_vote:             'Для того щоб оцінити відгук - Вам необхідно авторизуватися',
        form_text_short:           'Відгук не може бути таким коротким',
        form_text_short_caption:   'Короткий текст відгуку',
        form_name_short:           'Ваше ім\'я може складатися не менше ніж з 3-х букв',
        form_name_short_caption:   'Коротке Ваше ім\'я',
        form_name_not_unique:      'Ім\'я яке Ви вказали, вже використовується іншим клієнтом на нашому сайті. <br> За правилами нашого сайту імена якими підписуються клієнти - повинні бути унікальними.',
        code_length_error:         'Код повинен містити від 5-ти до 6-ти цифр. <br> І більше ніяких символів',
        save_error:                'При збереженні відкликання сталася помилка',
        save_error_caption:        'Помилка при збереженні',
        error_happened:            'Виникла помилка',
        form_answer_short:         'Відповідь не може бути така коротка',
        form_answer_short_caption: 'Короткий текст відгуку',

        modal_text_for_google:     'Дякуємо за Ваш відгук, будемо Вам дуже вдячні, якщо Ви ще, залишите відгук в Google.<br />' +
                                   '<a href="https://www.google.com/search?q=%D0%BC%D0%B0%D1%81%D1%82%D0%B5%D1%80+%D0%BF%D0%BB%D1%8E%D1%81&ie=utf-8&oe=utf-8&client=firefox-b-ab#lrd=0x472d5b40451a2fbd:0x6ef3646230615b12,1," id="googleTestimonialBtnInAlert" target="_blank">' +
                                       '<span id="SPAN_2">' +
                                           '<span id="SPAN_3"></span>' +
                                           '<span id="SPAN_4">Написати відгук Google</span>' +
                                       '</span>' +
                                   '</a>' ,
        modal_title_for_google:    'Дякуємо за відгук',
        modal_btn_for_google:      'Добре'
    },

	ideas: {
		already_voted:             'Ви вже оцінили цю пропозицію',
		your_own_comment:          'Ви не можете оцінювати свою пропозицію',
		error:                     'Помилка',
		login_to_vote:             'Для того щоб оцінити пропозицію - Вам необхідно авторизуватися',
		form_text_short:           'Пропозиція не може бути такою короткою',
		form_text_short_caption:   'Короткий текст пропозиції',
		form_name_short:           'Ваше ім\'я може складатися не менше ніж з 3-х букв',
		form_name_short_caption:   'Коротке Ваше ім\'я',
        form_name_not_unique:      'Имя которое Вы указали, уже используется другим клиентом на нашем сайте.<br>По правилам нашего сайта имена которыми подписываются клиенты - должны быть уникальными.',
        code_length_error:         'Код повинен містити від 5-ти до 6-ти цифр. <br> І більше ніяких символів',
		save_error:                'При збереженні сталася помилка',
		save_error_caption:        'Помилка при збереженні',
		error_happened:            'Виникла помилка',
		form_answer_short:         'Відповідь не може бути такою короткою',
		form_answer_short_caption: 'Короткий текст відгуку',
	},

    good: {
        show_all_codes: 'Показати всі коди',
        hide_all_codes: 'Приховати коди',
	    show_more_thumbs: 'ще фото',
	    hide_more_thumbs: 'менше фото',
        track_arrival_alert: 'Якщо товар з\'явиться на складі протягом місяця - Вам прийде СМС. <br> Якщо немає - поновіть статус очікування через місяць натиснувши на цю кнопку',
        track_arrival_alert_caption: 'Очікуємо товар',
        one_click_order_created: 'Ви успішно оформили замовлення в 1 клік.',
        one_click_existing_order_used: 'Ваш товар буде доданий до замовлення {order}.',
        one_click_order_phone: 'Телефон повинен складатися з {length} цифр. Вкажіть, будь ласка український номер телефону в форматі "+380 .."',
        one_click_order_created_caption: 'Замовлення успішно оформлене',
        one_click_order_manager_call: 'Чекайте дзвінка менеджера',

        one_click_no_quantity: 'Поле кількість не може бути порожнім',
        one_click_is_not_int: 'Поле кількість має бути числом',

        one_click: {
            enter_phone_number: 'Вкажіть ваш номер телефону:',
            buy: 'Купити в один клік',
            quantity: 'Кількість:',
            order: 'Замовити',
            close: 'Закрити форму',
            i_agree: 'Я згоден з <a href="/faq/pravila-i-uslovija-registracii.html" target="_blank" style="color:#fff">умовами роботи</a>',
            accept_agreement: 'Ви повинні прийняти умови роботи'
        },

        reviews: {
            name_short:            'Вкажіть ім\'я яке буде складатися не менше ніж з 3-х символів',
            name_short_caption:    'Занадто коротке ім\'я',
            comment_short:         'Коментар повинен містити не менше ніж 20 символів',
            comment_short_caption: 'Ваш коментар - занадто короткий',
            error_happened:        'Виникла помилка',
            comment_added:         'Дякуємо за Ваш коментар. Він буде доданий до товару після перевірки адміністратором.',
            comment_added_caption: 'Коментар доданий',
        },

        models: {
            not_found: 'Немає відповідних моделей'
        },

	    favorite: {
		    where_to_find: 'Товари в обраному ви зможете знайти на головній сторінці, у вкладці "Вибране"',
		    signup: 'Щоб скористатися функцією обраних товарів, Вам необхідно авторизуватися',
            confirm_remove: 'Ви впевнені?'
        },

        check_availability: {
            first_time: 'Ви можете перевірити наявність 10 разів на добу',
            limit_reached: 'Ви вичерпали ліміт перевірки наявності товарів на сьогодні. Перевірити наявність можна 10 разів на добу. Функція перевірки буде доступна завтра'
        }
    },

    catalog: {
        caption: 'Каталог товарів',
        click_to_see_count: 'Натисніть на кнопку, щоб перевірити кількість на складі',
        '3dphoto_hint_short': 'Цей товар можна покрутити в 3D',
        have_ucenka_products: 'Є знижений у ціні товар',
        price_small: 'ціна:',
        price_roznicnaya: 'Роздрібна ціна товару:',
        interest: 'Інтерес',
        add_to_favorite: 'Додати в обране',
        field_articul: 'Артикул:',
        add_to_cart: 'Додати в кошик',
        one_click_buy: 'Купити в 1 клік',
        goto_product: 'Детальніше',
        not_available: 'немає в наявності',
        is_available: 'в наявності',
        warehouse: 'На складі',
        shop: 'В магазині'
    },

    common: {
        enter_email:          'Введіть Вашу електронну пошту у відповідному полі',
        empty_email_caption:  'Не введений e-mail',
        email_format_message: 'E-mail може містити тільки латинські букви, цифри, точки, а також символ «@»',
        email_format_caption: 'Не вірний формат електронної пошти',
        enter_phone:          'Необхідно вказати номер мобільного телефону',
        enter_phone_caption:  'Невірний формат номера',
        phone_length:         'Номер телефону повинен містити {length, plural, one {# цифру} few {# цифри} many {# цифр} other {# цифр}}',
        ok_btn:               'OK',
        cancel_btn:           'Вiдмiна',
        name_format:          'Ім\'я повинно складатися більш ніж з 2-х символів',
        name_format_caption:  'Невірний формат імені',

        enter_city:     'Вкажіть населений пункт',
        enter_country:  'Вкажіть країну',
        error_happened: 'Вибачте, сталася помилка',

        work_time:          'Робочий час',
        work_time_continue: '.<br>Продовжити?',
        work_time_caption:  'Підтвердіть дію',
        work_time_yes:      'Так',
        work_time_no:       'Ні, дякую',

        fixing_leave_on:  'Залишити включеним',
        fixing_leave_off: 'Залишити відключеним',
        fixing_turn_off:  'Відключити',
        fixing_turn_on:   'Увімкнути',

        alert_default_caption:   'Увага!',
        alert_default_yes:       'Так',
        alert_default_no:        'Ні',
        confirm_default_caption: 'Зробіть вибір',
        confirm_default_yes:     'Так',
        confirm_default_no:      'Ні',
        cancel: 'Скасувати',

        open_call_text:    'Дана кнопка дозволяє зателефонувати до нас прям з сайту, без використання додаткових програм, або телефонів. <br> Дзвонити можна з будь-якої точки світу абсолютно безкоштовно. <br> <br> Для того, щоб дзвінок був успішним - у Вас повинен бути мікрофон. <br> Крім цього при підключенні у Вас з\'явиться вікно з настройками, де Вам буде запропоновано дозволити доступ до Вашого мікрофону. Вам необхідно підтвердити дозвіл, в іншому випадку ми не будемо Вас чути. <br> <br> <font color="red"> Під час дзвінка не переходите на інші сторінки інакше дзвінок обірветься </font>. <br> Більш детально <a href="/ua/faq/chto-takoe-on-line-zvonok.html" title="Натисніть, щоб перейти до статті">читайте тут.</a>',
        open_call_caption: 'Будь ласка, прочитайте.',

        skype_call_text:    '1. При дзвінку через Skype час виклику (дозвону) може скласти від декількох секунд до однієї хвилини. <br> <br> 2. Зв\'язок через скайп може бути тільки у вигляді дзвінків до нас. Чат або дзвінки від нас до Вас недоступні. <br> <br> Детальніше про дзвінки Skype <a href="' + '/ua/faq/chto-takoe-on-line-zvonok.html" title="Натисніть, щоб перейти до статті">читайте тут.</a>',
        skype_call_caption: 'Увага',

        restore_password_title: 'Відновити пароль',
        save_password: 'Зберегти пароль',
        to_your_phone: 'На ваш моб. телефон',
        confirm_code_sent: 'надісланий код для відновлення пароля',
        enter_new_password: 'Введіть новий пароль',
        enter_confirm_code: 'Введіть код з СМС',
        nothing_found: 'Нічого не знайдено',

        back_to_home: '&larr; Перейти на головну',
        price_upper: 'ЦІНА',
    },

    user: {
        logout_confirm:            'Ви точно хочете вийти з Вашого облікового запису?',
        logout_caption:            'Вихід',
        logout_yes:                'Так',
        logout_no:                 'Ні',
        confirm_code_send_error:   'Сталася помилка при відправленні коду',
        confirm_code_wrong:        'Код підтвердження введено не вірно, у Вас залишилася 1 спроба. <br> Якщо код відправлявся Вам кілька разів, то вводити треба саме останній.',
        confirm_code_second_wrong: 'Код підтвердження двічі введений не вірно. Витримайте паузу, перезавантажте сторінку, та спробуйте ще раз. Якщо SMS довго не приходить - спробуйте повторити пізніше',
        confirm_code_verify_wrong: 'Сталася помилка під час перевірки коду',
        password_short:            'Пароль занадто короткий',
        password_short_length:     'Пароль повинен бути не менше 5-ти символів',
        password_format:           'Пароль повинен складатися тільки з цифр і англійських букв',
        password_forgot:           'Забули пароль',
        recovery_code_sent:        'На ваш моб телефон отправлен код подтверждения для восстановления пароля',

        password_format_caption:   'Невірний формат пароля',
        phone_length:              'Телефон повинен складатися з {length} цифр',
        phone_length_caption:      'Невірний формат телефону',
        phone_required:            'Реєстрація можлива тільки на номер мобільного',
        reg_agree:                 'Для реєстрації, Ви повинні прийняти умови реєстрації',
        enter_confirm_code:        'Введіть код підтвердження з SMS',
        confirm_code_wrong_short:  'Невірно введений код',
        error_happened:            'Виникла помилка',
    },

    operator: {
        something_wrong:   'Щось пішло не так',
        enter_credentials: 'Введіть номер і пароль',
        sure_logout:       'Точно вийти?',
    },

    order: {
        error_happened:                    'Виникла помилка',
        no_accept_rules:                   'Ви повинні погодитися з правилами',
        phone_taken:                       'В нашій базі вже існує клієнт з таким номером телефону. <br> Якщо це Ваш номер - натисніть «<font color=blue>Я постійний клієнт</font>» і авторизуйтесь.',
        phone_taken_caption:               'Ви вже зареєстровані',
        phone_taken_short:                 'В нашій базі вже існує інший клієнт з таким номером телефону.',
        phone_taken_short_caption:         'Чужий номер',
        phone_exists:                      'Ваш телефон вже є в нашій системі, будь ласка авторизуйтесь',
        format_words:                      '{field} може містити лише українські, російські літери і не може містити інших символів або пробілів',
        format_words_en:                   'За рішенням Укрпошти - всі дані для міжнародних відправлень повинні бути заповнені англійською мовоюі',
        format_words_caption:              'Правильно введіть {field}',
        format_length:                     '{field} не може бути коротше 2-х символів',
        format_length_caption:             'Вкажіть Ваше {field}',
        no_city:                           'Ми не знайшли такого населеного пункту в нашій базі. <br> Будь ласка, виберіть населений пункт зі списку. <br> Якщо ж там немає того, що Вам треба - зверніться до нас за телефоном в робочий час.',
        no_city_caption:                   'Виберіть місто чи селище зі списку',
        auth_error:                        'Помилка авторизації',
        pass_format:                       'Пароль повинен складатися тільки з цифр і англійських букв',
        pass_format_caption:               'Невірний формат пароля',
        pass_length:                       'Пароль занадто короткий',
        pass_length_caption:               'Невірний формат пароля',
        phone_length:                      'Телефон повинен складатися з {length} цифр',
        phone_length_caption:              'Невірний формат номера',
        set_middlename_caption:            'Ваше по батькові',
        set_middlename:                    'Вкажіть Ваше по батькові',
        select_delivery:                   'Вкажіть службу доставки і іншу інформацію',
        select_delivery_caption:           'Ви не вказали службу доставки',
        select_delivery_method:            'Вкажіть спосіб доставки',
        select_delivery_method_caption:    'Ви не вказали спосіб доставки',
        select_np_departament:             'Вкажіть відділення Нової Пошти на яке необхідно доставити посилку',
        select_np_departament_caption:     'Ви не вказали відділення',
        select_meest_departament:          'Вкажіть відділення Meest Пошти на яке необхідно доставити посилку',
        select_meest_departament_caption:  'Ви не вказали відділення',
        select_payment_method:             'Вкажіть спосіб оплати за товар',
        select_payment_method_caption:     'Ви не вказали спосіб оплати',
        select_obreshtovka:                'Вкажіть решетувати товар чи ні?',
        select_obreshtovka_caption:        'Решетування потрібно?',
        order_error:                       'При оформленні замовлення сталася помилка, якщо це буде повторюватися зверніться до нас за телефоном',
        street_length:                     'Назва вулиці повинно містити не менше 4-х символів.',
        street_length_caption:             'Вкажіть вулицю',
        street_format:                     'У назві вулиці можна використовувати тільки українські та російські літери, цифри, а також точку і дефіс. Інші символи заборонені.',
        street_format_caption:             'Не вірний формат вулиці',
        enter_street:                      'Введіть назву вулиці, куди треба доставити посилку',
        enter_street_en:                   'За рішенням Укрпошти - всі дані для міжнародних відправлень повинні бути заповнені англійською мовою',
        enter_region:                      'Введіть назву області, регіону ..., куди треба доставити посилку. Для введення дозволені тільки англійські і російські літери, а також пробіл і дефіс.',
        enter_region_en:                   'За рішенням Укрпошти - всі дані для міжнародних відправлень повинні бути заповнені англійською мовою',
        enter_region_caption:              'Не вірний формат області',
        enter_city:                        'Введіть назву міста, куди треба доставити посилку. Для введення дозволені тільки англійські і російські літери, а також пробіл і дефіс.',
        enter_city_en:                     'За рішенням Укрпошти - всі дані для міжнародних відправлень повинні бути заповнені англійською мовою',
        enter_city_caption:                'Не вірний формат міста',
        index_format:                      'Поштовий індекс повинен складатися з 4-8 цифр.',
        index_format_caption:              'Вкажіть поштовий індекс',
        house_format:                      'Номер будинку може містити тільки цифри, українські та російські літери, а також дефіс і коса риска. Інші символи заборонені.',
        house_format_en:                   'За рішенням Укрпошти - всі дані для міжнародних відправлень повинні бути заповнені англійською мовою',
        house_format_caption:              'Не вірний формат номера будинку',
        error_1:                           'Помилка 1',
        obrestovka_abroad_denied:          'Ми не можемо оформити це замовлення в іншу країну, так як в ньому є крихкий товар, який ми не відправляємо за межі України.',
        obrestovka_abroad_denied_caption:  'Видаліть крихкий товар із замовлення',
        dont_call_if_all_good:             'Мені можна не дзвонити, якщо все є і ціни актуальні.',
        dont_call_send:                    'Мені можна не дзвонити, якщо все є і ціни актуальні, а відразу переводити на відправку.',
        dont_call_pay:                     'Мені можна не дзвонити, якщо все є і ціни актуальні, а відразу переводити на оплату.',
        please_agree_rules:                'Ви не підтвердили згоди з умовами роботи нашого магазину. <br> Прочитайте «умови роботи» і поставте галочку, що Ви згодні з ними. <br> Тільки після цього, ви зможете продовжити оформлення замовлення.',
        please_agree_rules_caption:        'Підтвердіть згоду з правилами',
    },

    seo: {
        title_length:      'Назва не може бути коротше 10-ти символів',
        text_length:       'SEO текст не може бути коротше 100-ти символів',
        text_exists:       'У цьому розділі вже існує текст для всього розділу',
        generation_exists: 'У цьому розділі вже існує текст генерації',
        error_happened:    'Виникла помилка',
        enter_pass:        'Введіть пароль',
        delete_all_1:      'Видалити ВСІ згенеровані тексти для цього розділу?',
        delete_all_2:      'Точно видалити ВСІ згенеровані тексти для цього розділу?',
        delete_all_3:      'Точно-точно видалити ВСІ згенеровані тексти для цього розділу?',
        delete_all_4:      'Ти готовий потім отримати піздюлей, якщо цього не треба було робити?',
        deleted:           'Видалено!',
        available_title_length: 'Длина Title должна быть от 45 до 255 символов',
        available_description_length: 'Длина Description должна быть от 130 до 300 символов',
        available_h1_length: 'Значение H1 может отсутствовать или должно быть длиной от 20 до 75 символов',
    },

    filters: {
        enter_pass:     'Введіть пароль',
        remove_desc:    'Видалити цей опис?',
        error_happened: 'Виникла помилка',
	    no_content:     'Немає відповідних товарів'
    },

    email: {
        already_sent_title: 'Вже відправлено',
        already_sent: 'Лист з підтвердженням уже відправлено. Якщо не прийшов, спробуйте трохи пізніше.',
        just_sent_title: 'Відправили лист',
        just_sent: 'Відправили лист з підтвердженням, перевірте свою поштову скриньку'
    },

    module: {
        added_to_cart:          'Модуль доданий в кошик',
        added:                  'Додано',
        you_can_accept_rules:   'Ви повинні погодитися з правилами',
        specify_brand:          'Вкажіть бренд',
        specify_technic:        'Вкажіть техніку',
        specify_service:        'Вкажіть послугу',
        specify_declaration:    'Вкажіть коректну декларацію',
        specify_comment:        'Вкажіть коментар',
        enter_brand: 'Виберіть бренд',
    },

    motor: {
        added_to_cart:          'Мотор добавлен в корзину',
        added:                  'Додано',
        specify_repair_type:    'Вкажіть тип ремонту',
        you_can_accept_rules:   'Ви повинні погодитися з правилами',
        specify_declaration:    'Вкажіть коректну декларацію',
    },

    spider: {
        added_to_cart:          'Хрестовина була додана в кошик',
        added:                  'Додано',
        you_can_accept_rules:   'Ви повинні погодитися з правилами',
        specify_declaration:    'Вкажіть коректну декларацію',
    },

    delivery_page: {
        select_city: 'Виберіть місто',
        enter_country: 'Вкажіть країну',
        enter_city: 'Вкажіть місто',
        set_payment_type: 'Вкажіть тип оплати',
        address_delivery_error: 'Адресна доставка можлива тільки при передоплаті',
        enter_weight: 'Введіть вагу',
        enter_cost: 'Введіть вартість',
        parameters_error: 'Немає можливості доставити з такими параметрами'
    },

    preorder: {
        with_privat24: 'використовуючи Приват24',
        with_credit_card: 'використовуючи кредитну карту',
        with_terminal: 'через термінал',
        with_requisites: 'за реквізитами',
        using_privat24: 'Використовуючи Приват24',
        using_credit_card: 'Використовуючи кредитну карту',
        using_terminal: 'Використовуючи термінал',
        using_requisites: 'Використовуючи реквізити',
        credit_desc: `Якщо Ви регулярно купуєте в нашому магазині, і використовуєте цей
спосіб для поповнення балансу - Ви можете прив'язати Вашу карту до
цього аккаунту. Це полегшить процес наступних оплат. <br/> <br/>

Для цього достатньо просто поставити галочку поруч з «запам'ятати
карту для оплат »і зробити будь-яку оплату цим способом. після
того, як ми отримаємо від Вас цю оплату, ми збережемо необхідні
дані для того, щоб полегшити Ваші наступні оплати. <br/> <br/>

І наступного разу у Вас в меню з'явиться додатковий спосіб
оплати, за допомогою Вашої збереженої карти. <br/> <br/>

Але не переживайте, ніхто крім Вас не зможе провести оплату.
Все, важливі, дані які нам передає банк, після Вашої
оплати - зашифровані, і розшифрувати їх може тільки той же
банк. Чи не зашифрована тільки загальна інформація про карту, така як,
Прізвище Ім'я, останні цифри карти, і тип карти. <br/> <br/>

Більш того, при кожній оплаті банк вимагатиме Ваша особиста
підтвердження. <br/> <br/>

Ну і звичайно, Ви можете видалити цю карту в будь-який
момент. <br/> <br/>

Якщо у Вас залишилися питання - телефонуйте нам в робочий час, і ми
на них відповімо.`,
        order_completed_payment: 'Ваше замовлення оформлене і чекає оплати.',
        order_completed_desc: 'Якщо у Вас є питання або сумніви щодо оформленого замовлення, - краще зв\'яжіться з менеджером, щоб проконсультуватися, якщо немає, - <b> будь ласка, оплатіть Ваше замовлення </b>.',
        balance_info: 'Інформація про баланс:',
        current_balance: 'Ваш поточний баланс:',
        balance_negative: 'На вашому балансі від\'ємний баланс (Борг перед магазином). Вам потрібно оплатити борг перед магазином в розмірі <b> {balance} грн </b> + сума поточного замовлення <b>{order_sum} &nbsp; грн.<b/>',
        pay_order_sum: 'Оплатити суму замовлення.',
        including_debt: 'Включаючи суму боргу:',
        on_your_balance: 'На вашому балансі',
        balance_enough: 'Цього достатньо для оплати замовлення.',
        use_balance: 'Оплатити <b>замовлення засобами з балансу </b>',
        you_need_to_surcharge: 'Для повної оплати Вам потрібно доплатити <b>ще {charge} &nbsp; грн. </b>',
        use_surcharge: 'Доплатити',
        you_can_pay_order_sum: 'Ви можете оплатити всю суму замовлення',
        pay_full: 'Оплатити всю суму',
        you_can_use_credit_limit: 'Ви можете оплатити замовлення в рахунок кредитного ліміту.',
        pay_credit_limit: 'Оплатити замовлення в рахунок кредитного ліміту',
        you_can_pay_later: 'Ви можете оплатити замовлення пізніше. Це можна буде зробити через <a href={url}> особистий кабінет</a>.',
        and_bank_fee: '+ комісія банка <b>{fee} грн</b>',
        pay_later: 'Оплатити пізніше',
        privat24: `<b>Для оплати Приват 24:</b><br/>
        <b>1.</b> Натисніть кнопку «Оплатити»<br/>
        <b>2.</b> Клацніть «Інший спосіб оплати»`,
        requisites: {
            recipient: 'Одержувач платежу:',
            account: 'Розрахунковий рахунок:',
            erpoy: 'Код ОКПО(ЕРПОУ):',
            mfo: 'МФО:',
            bank: 'Установа банку:',
            sum: 'Сума платежу:',
            purpose: 'Призначення платежу:',
            print: 'Роздрукувати реквізити',
            send_sms: 'Надіслати реквізити по смс',
            send_mail: 'Надіслати реквізити на пошту',
            received_finish: 'Реквізити отримані, завершити оформлення',
            minimize: 'Згорнути',
        },
        enter_phone: 'Вкажіть номер телефону',
        enter_email: 'Вкажіть email',
        credit_card: 'Кредитна карта для оплати:',
        credit_card_other: 'Оплатити іншою картою',
        save_credit_card_title: 'Збереження банківських карт',
        save_card: 'Зберегти карту',
        result_sum: 'Разом до оплати:'
    },

    breadcrumbs: {
        go_back: 'Повернутися'
    },

    menu: {
        see_more: 'Дивитися ще',
        favorites: 'Вибрані товари'
    },

    bigPhoto: {
        open: 'Оригінальне фото в окремому вікні'
    },
};
